export const tagStyles = {
  // Styles for the base style
  baseStyle: {},
  // Styles for the size variations
  sizes: {},
  // Styles for the visual style variations
  variants: {
    easy: {
      mx: "1vw",
      backgroundColor: "crimson",
      color: "white",
      fontWeight: "bold",
      fontSize: "xs",
    },
    easySelected: {
      mx: "1vw",
      backgroundColor: "crimson",
      color: "blue",
      fontWeight: "bold",
      fontSize: "xs",
    },
  },
  // The default `size` or `variant` values
  defaultProps: {},
};
